import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset the scroll position on every route change. A client-side router swaps the page without
 * touching the window's scroll offset, so a link followed from the bottom of one page — the
 * "Start Your Claim" call-to-action, say — otherwise lands you halfway down the next one.
 *
 * Instant, like native navigation: an animated glide travels over content the customer never sees
 * and only delays the arrival. `'instant'` is passed explicitly so the intent survives anyone
 * re-adding a global `scroll-behavior: smooth` rule, under which `'auto'` resolves to *smooth*.
 *
 * Renders nothing; mount it inside the router, above the routes.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
